export default __webpack_public_path__ + "static/heroBg-6e345dc21e303a8e917729e59c9a2d76.png";